import React from "react"
import {
  type IconProps,
  iconColorCss,
  iconSizeCss,
} from "@myvp/shared/src/styles/icon-utils"

const Home = (props: IconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    focusable="false"
    css={[iconColorCss(props.color), iconSizeCss(props.size)]}
  >
    <path
      d="M11.3789 2.21619C11.7428 1.92786 12.2572 1.92786 12.6211 2.21619L20.4863 8.45642C21.4425 9.21511 21.9999 10.3696 22 11.5902V19.9994C22 21.104 21.1046 21.9994 20 21.9994H4C2.89543 21.9994 2 21.104 2 19.9994V11.5902C2.00012 10.4459 2.48978 9.35927 3.33887 8.60291L3.51367 8.45642L11.3789 2.21619ZM4.75684 10.0228C4.27879 10.4021 4.00013 10.98 4 11.5902V19.9994H9.22754V15.0062C9.2277 14.4541 9.67536 14.0062 10.2275 14.0062H13.7734C14.3253 14.0066 14.7733 14.4543 14.7734 15.0062V19.9994H20V11.5902C19.9999 10.98 19.7212 10.4021 19.2432 10.0228L12 4.27478L4.75684 10.0228ZM10.2275 19.9994H13.7734V15.0062H10.2275V19.9994Z"
      fill="var(--color)"
    />
  </svg>
)

export default Home
